import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

import RequestCard from './card/RequestCard';
import { selectHistory } from '../../redux/ai-studio/aiStudioReducer';
import CommonLoader from '../../components/common-loader/CommonLoader';
import EmptyHistory from './empty-history/EmptyHistory';

import scss from './RequestsHistory.module.scss';

function RequestsHistory({ actionOptions = [] }) {
  const dispatch = useDispatch();
  const { t } = useTranslation('studio');

  const requestsHistory = useSelector((state) => state.aiStudio.requestsHistory);
  const selectedRequest = useSelector((state) => state.aiStudio.selectedRequest);
  const isRequestsHistoryLoading = useSelector((state) => state.aiStudio.isRequestsHistoryLoading);

  const handleSelectHistory = (id) => {
    dispatch(selectHistory(id));
  };

  return (
    <div className={scss.wrapper}>
      <span className={scss.title}>{t('requestsHistory')}:</span>

      <div className={scss.requests}>
        {requestsHistory.length ? (
          requestsHistory.map((request) => (
            <RequestCard
              key={request.id}
              request={request}
              isSelected={selectedRequest === request.id}
              onSelect={handleSelectHistory}
              actionOptions={actionOptions}
            />
          ))
        ) : (
          <EmptyHistory />
        )}

        <CommonLoader isLoading={isRequestsHistoryLoading} />
      </div>
    </div>
  );
}

export default RequestsHistory;
